module.exports = __webpack_public_path__ + "static/media/BarraMulticolor.5ba68c55.jpg";